// Public surface of the Lyric Tester record/replay engine (P0 spike).
// Framework-agnostic, same-origin, reusable by the future floating widget.
const selector = require('./selector');
const dom = require('./dom');
const { Recorder } = require('./recorder');
const { Replayer } = require('./replayer');

module.exports = {
    Recorder,
    Replayer,
    describe: selector.describe,
    resolve: selector.resolve,
    dom,
    selector,
};
